<template>
  <v-container v-if="transaction" id="transaction-view" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <MaterialCard
          elevation="0"
          color="primary"
          title="Transactie"
          class="tour-start"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              Transactie {{ transaction.pos_transaction_number }}
              <span class="body-1">— algemene informatie</span>
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Bonnummer"
                    disabled
                    :value="transaction.pos_transaction_number"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Tijd"
                    disabled
                    :value="transaction.time | datetime"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Totaal bedrag"
                    disabled
                    :value="(transaction.total_price / 100) | currency"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Type"
                    disabled
                    :value="transaction.type | transaction_type"
                  />
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    label="Locatie"
                    disabled
                    :value="transaction.location.name"
                  />
                </v-col>
                <v-col v-if="transaction.prepaid_mutations[0]" cols="6" md="6">
                  <v-text-field
                    label="Oud balans"
                    disabled
                    :value="
                      ((transaction.prepaid_mutations[0].balance -
                        transaction.prepaid_mutations[0].delta) /
                        100)
                        | currency
                    "
                  />
                </v-col>
                <v-col v-if="transaction.prepaid_mutations[0]" cols="6" md="6">
                  <v-text-field
                    label="Nieuw balans"
                    disabled
                    :value="
                      (transaction.prepaid_mutations[0].balance / 100)
                        | currency
                    "
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </MaterialCard>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" xl="6" lg="6" md="12" sm="12">
        <MaterialCard
          elevation="0"
          color="primary"
          title="Producten"
          class="tour-start"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              Producten
            </div>
          </template>
          <v-data-table
            :headers="headers"
            :items="transaction.transaction_products"
            :items-per-page="5"
            :sort-desc="[false, true]"
            multi-sort
          >
            <template v-slot:item.total_price="{ item }">
              {{ (item.total_price / 100) | currency }}
            </template>
          </v-data-table>
        </MaterialCard>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="12" sm="12">
        <MaterialCard
          elevation="0"
          color="primary"
          title="Betalingen"
          class="tour-start"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              Betalingen
            </div>
          </template>
          <v-data-table
            :headers="payment_headers"
            :items="transaction.transaction_payments"
            :items-per-page="5"
            :sort-desc="[false, true]"
            multi-sort
          >
            <template v-slot:item.amount="{ item }">
              {{ (item.amount / 100) | currency }}
            </template>
          </v-data-table>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCard from "../../../../../components/views/MaterialCard";
import { transaction_view } from "../../../../../mixins/transaction";
export default {
  name: "TransactionView",
  components: { MaterialCard },
  mixins: [transaction_view]
};
</script>
